<template>
  <form @submit.prevent="submit" id="newArtikel" class="mb-5">
    {{id}}
    <div class="form-group">
      <label for="input1">Naam</label>
      <input type="text" id="input1" v-model="item.naam" class="form-control" placeholder="Naam">
    </div>
    <div class="form-group">
      <label for="input2">Details</label>
      <input
        type="text"
        id="input2"
        v-model="item.naam_detail"
        class="form-control"
        placeholder="Details"
      >
    </div>
    <div class="form-group">
      <label for="input3">Omschrijving</label>
      <input
        type="text"
        id="input3"
        v-model="item.description"
        class="form-control"
        placeholder="Omschrijving"
      >
    </div>
    <div class="form-group">
      <label for="input4">Prijs</label>
      <input
        type="number"
        id="input4"
        v-model.number="item.prijs"
        class="form-control"
        placeholder="0"
      >
    </div>
    <div class="form-group">
      <label for="input4">Prijs gegeven</label>
      <input
        type="number"
        id="input6"
        v-model.number="item.prijs_donated"
        class="form-control"
        placeholder="0"
      >
    </div>
    <div class="form-group">
      <label for="input5">Url</label>
      <input type="text" id="input5" v-model="item.url" class="form-control" placeholder="Url">
    </div>
    <div class="form-group ml-4">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" :true-value="true" :false-value="false" id="defaultCheck1" v-model="item.show">
        <label class="form-check-label" for="defaultCheck1">Tonen</label>
      </div>

    </div>
    <!-- <div class="custom-file mb-3">
      <input type="file" class="form-control custom-file-input" @change="postImg" id="file">
      <label class="custom-file-label" for="customFile">{{label}}</label>
    </div>-->
    <br>
    <h5>Cover</h5>
    <file-pond
      name="cover"
      label-idle="Cover foto"
      allow-multiple="false"
      accepted-file-types="image/jpeg, image/png"
      :server="serverCover"
      imageResizeTargetWidth="800"
      imageResizeTargetHeight="800"
      imageResizeMode="contain"
      allowImageCrop="false"
      :imageTransformVariants="thumbnail"
    ></file-pond>
    <div class="card m-3 w-50 mx-auto" v-if="id">
      <img :src="item.img" alt class="img-fluid card-img">
      <div class="card-body">
        <h5 class="card-title">Huidige cover</h5>
      </div>
    </div>
    <h5>Carousel</h5>
    <file-pond
      name="test"
      label-idle="Sleep foto's hier!"
      allow-multiple="true"
      accepted-file-types="image/jpeg, image/png"
      :server="serverCarousel"
      imageResizeTargetWidth="800"
      imageResizeTargetHeight="800"
      imageResizeMode="contain"
      imageCropAspectRatio="4:3"
      allowImageCrop="true"
    />
    <button class="btn btn-primary" type="submit" v-if="!saving">Opslaan!</button>
    <div class="mt-5 card-columns">
      <div class="card" v-for="(img, idx) in item.carousel" :key="'img'+idx">
        <img :src="img" style="cursor:x, auto" class="card-img img-fluid">
        <div class="card-body">
          <button class="btn btn-outline-primary" @click.prevent="removeImage(idx)">Verwijder</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
// filepond

let function5 = () => {
  console.log("error");
};
let guid = () => {
  let s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4();
};
export default {
  data() {
    return {
      saving: false,
      item: {
        carousel: [],
        prijs_donated: 0,
        show:true
      },
      img: undefined,
      label: "Kies een foto"
    };
  },
  props: ["id"],
  components: {
    filePond: () => import(/* webpackChunkName: 'filepond' */ "./filepond")
  },
  computed: {
    thumbnail() {
      return {
        thumbnail_: transforms => {
          transforms.resize.size.width = 64;
          return transforms;
        }
      };
    },
    serverCarousel() {
      return {
        process: this.process("carousel")
      };
    },
    serverCover() {
      return {
        process: this.process("cover")
      };
    }
  },
  methods: {
    process(typeOfImage) {
      return async (
        fieldName,
        file,
        metadataOrig,
        load,
        error,
        progress,
        abort
      ) => {
        // if (!this.saving) this.saving = 0;
        // this.saving -= 1;
        let item = this.item;
        try {
          let metadata = {
            contentType: file.type
          };
          let ref = this.$firebase.storage().ref();
          try {
            let uid = guid();
            let thumbnail = this.$_.find(file, x => x.name == "thumbnail_");
            let large = this.$_.find(file, x => x.name != "thumbnail_");
            let task = ref.child(`/artikels/${uid}`).put(large.file, metadata);
            // let taskThumb = ref
            //   .child(`/artikels/thumbnail_${uid}`)
            //   .put(thumbnail.file, metadata);
            task.on(
              "state_changed",
              snapshot => {
                progress(
                  true,
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
                  100
                );
              },
              err => {
                this.$alertify.error(err);
                error();
              },
              async () => {
                let url = await task.snapshot.ref.getDownloadURL();
                if (typeOfImage == "carousel") {
                  if (item.carousel) {
                    item.carousel.push(url);
                  } else {
                    item.carousel = [url];
                  }
                } else {
                  // let thumb_url = await taskThumb.snapshot.ref.getDownloadURL();
                  item.img = url;
                  // item.img_thumb = thumb_url;
                  item.ratio =
                    parseFloat(metadataOrig.size.height) /
                    parseFloat(metadataOrig.size.width);
                  if (metadataOrig.exif && metadataOrig.exif.orientation == 6)
                    item.ratio = 1 / item.ratio;

                  var reader = new FileReader();
                  reader.addEventListener(
                    "load",
                    function() {
                      item.img_thumb = reader.result;
                    },
                    false
                  );

                  reader.readAsDataURL(thumbnail.file);
                }

                load("1");
                // this.saving += 1;
              }
            );
          } catch (err) {
            this.$alertify.error(JSON.stringify(err));
            error();
          }
        } catch (err) {
          this.$alertify.error(JSON.stringify(err));
          error();
        }
        return {
          abort: () => {
            abort();
          }
        };
      };
    },
    submit() {
      let item = this.item;
      if (!item.naam) {
        this.$alertify.alert("Naam ontbreekt");
        return;
      } else if (item.prijs == 0) {
        this.$alertify.alert("Prijs ontbreekt");
        return;
      } else if (!item.img) {
        this.$alertify.alert("Nog geen cover foto ingesteld!");
        return;
      }
      if (!item.prijs_donated) item.prijs_donated = 0;
      if (!item.carousel || this.$_.isEmpty(item.carousel)) {
        item.carousel = [item.img];
      }
      if (this.id) {
        this.$alertify.confirm(
          `Zeker dat je artikel ${item.naam} wil wijzigen?`,
          () => {
            this.$firebase
              .firestore()
              .collection("artikels")
              .doc(this.id)
              .set(this.item)
              .then(res => {
                this.$router.replace(`/detail/${this.id}`);
              });
          }
        );
      } else {
        this.$firebase
          .firestore()
          .collection("artikels")
          .add(item)
          .then(res => {
            this.$alertify.success("Opgeslagen met id " + res.id);
            this.item = {};
            this.img = undefined;
            this.label = "Kies een foto";
            document.getElementById("newArtikel").reset();
            this.$router.push(`/detail/${res.id}`);
          })
          .catch(err => {
            this.$alertify.error("Oei, 't is mislukt!");
          });
      }
    },
    async postImg(evt) {
      try {
        let file = evt.target.files[0];
        let metadata = {
          contentType: file.type
        };
        let ref = this.$firebase.storage().ref();
        try {
          let uid = guid();
          let snapshot = await ref
            .child(`/artikels/${uid}`)
            .put(file, metadata);
          let url = await snapshot.ref.getDownloadURL();
          this.img = url;
          this.item.img = url;
          this.label = file.name;
          this.$alertify.success("Gelukt!");
        } catch (err) {
          this.$alertify.error(err);
        }
      } catch (err) {
        this.$alertify.error(JSON.stringify(err));
      }
    },
    removeImage(idx) {
      this.$alertify.confirm("Zeker dat je deze foto wil verwijderen?", () =>
        this.item.carousel.splice(idx, 1)
      );
    }
  },
  async mounted() {
    if (this.id) {
      // this.saving = 0;
      let doc = await this.$firebase
        .firestore()
        .collection("artikels")
        .doc(this.id)
        .get();
      this.item = doc.data();
    }
  }
};
</script>
